export const LVN_PROTOCOL_ITEMS = [
    // 0: Job Header
    {
        id: 0,
        type: 'header',
        title: "Job Description",
        position: "Licensed Vocational Nurse",
        reportsTo: "Clinical Supervisor"
    },
    // 1: Qualifications Section
    {
        id: 1,
        type: 'section',
        title: "QUALIFICATIONS:",
        list: [
            "Is currently a licensed Vocational Nurse in the State of California.",
            "Has at least one-year experience as a professional nurse.",
            "Has excellent clinical judgment, knowledge of current nursing practices, observation, and communication skills.",
            "Current CPR Certification.",
            "Current and satisfactory report on pre-employment physical examination including Mantoux TB Test or chest X-ray as required by Agency policies and procedures.",
            "Able to walk, bend, stoop, and lift objects weighing up to 25 lbs.",
            "Is fluent in English.",
            "Is self-directed and able to work with little supervision and has good organizational skills.",
            "Must be a licensed driver with an automobile that is insured in accordance with state and/or organizational requirements and is in good working order.",
            "Is able to use professional judgment in reporting and seeking assistance from both peers and supervisors."
        ]
    },
    // 2: Essential Duties and Responsibilities
    {
        id: 2,
        type: 'section',
        title: "ESSENTIAL DUTIES AND RESPONSIBILITIES:",
        text: "The following is representation of the major duties and responsibilities of this position. The Agency will make reasonable accommodations to allow otherwise qualified applicants with disabilities to perform essential functions.",
        duties: [
            "Contributes to the development of a plan of nursing action based on existing problems, expected patient response, and the Plan of Care.",
            "Performs duties consistent with the Vocational Nursing Practice Act.",
            "Implements safe, therapeutic care of patients with overt needs in supervised / controlled situations as initiated in the Plan of Care by the physician in consultation with the Case Manager/RN and the interdisciplinary team.",
            "Utilizes resources (patient, family, staff, outside personnel, agencies/organizations) to contribute to the Plan of Care.",
            "Maintains current knowledge and skills for documenting care to meet Regulatory and third party payer requirements. Prepares documentation and clinical/progress notes. Documents clearly and concisely, using proper notation and Agency abbreviations. Submits all documentation within the timelines established by the Agency.",
            "Explains test, procedures, disease process, and provides other health education to patient, family, and/or caregiver. Documents patient/family/caregiver response to care and teaching.",
            "Notifies the patient's attending physician, dentist or podiatrist and other professional persons and responsible staff of significant changes in the patient's condition. \"Significant changes\" include those changes that suggest the need to modify or develop a plan of treatment or plan of care.",
            "May teach basic patient care to ancillary personnel and CHHAs.",
            "Participates in coordination of home health services, appropriately reporting the need for other disciplines to the case manager and/or clinical supervisor.",
            "Reports on the patient's condition and changing patient status to the Case Manager and/or clinical supervisor.",
            "Regularly attends and participates in scheduled case conferences, staff meetings and Agency in-services.",
            "Attends and/or participates in Clinical Record Reviews and other Quality Improvement functions as directed by supervisor.",
            "Prevents spread of infection and disease by proper disposal of contaminated materials and by adhering to Standard Precautions.",
            "Maintains/conserves confidentiality of patient and Agency information at all times.",
            "Regularly assesses own nursing skills and educational needs to meet the nursing care requirements of patients assigned for care. Upgrades professional skills and attends in-services and continuing education classes as needed.",
            "Provides those services requiring nursing skills in accordance with the plan of treatment of plan of care.",
            "Educates and instructs the patient, patient's family, or staff as required. Teaching patient information is limited to that which is outlined in and consistent with the licensed Vocational Nurse Practice Act.",
            "Assists the patient in learning appropriate self-care techniques.",
            "Assists the physician and registered nurse in performing specialized procedures. Prepares equipment and materials for treatments observing aseptic technique as required.",
            "Conforms to all Agency policies and procedures."
        ]
    },
    // 3: Signature Block
    {
        id: 3,
        type: 'signature',
        fields: [
            { label: "Employee Signature", name: "employeeSignature" },
            { label: "Date", name: "signatureDate", inputType: "date" }
        ]
    }
];
